import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { KIOSK_PRODUCT_ADD_PAGE_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { KioskProductAddPageScenarioContent } from '@front-platform/content-builder';

import {
  KioskProductAddPageDataSource,
  KioskProductAddPageViewModel,
} from './kiosk-product-add-page-view-model';

function toPreviewViewModel(
  content: KioskProductAddPageScenarioContent,
): KioskProductAddPageViewModel {
  return {
    shopId: content.shopId,
    productId: content.product.id,
    product: content.product as unknown as KioskProductAddPageViewModel['product'],
    shop: content.shop,
  };
}

@Injectable()
export class KioskProductAddPagePreviewDataSource implements KioskProductAddPageDataSource {
  readonly vm$: Observable<KioskProductAddPageViewModel | null> = previewScenarioForBloc$(
    KIOSK_PRODUCT_ADD_PAGE_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return null;
      }

      const content = previewScenarioData<KioskProductAddPageScenarioContent>(
        scenario,
        KIOSK_PRODUCT_ADD_PAGE_COMPONENT,
      );
      return content ? toPreviewViewModel(content) : null;
    }),
  );
}
